<template>
  <div>
    <div class="mt-6 flex flex-col">
      <div class="w-full md:max-w-3xl md:mx-auto px-4 md:pt-16">
        <h1 class="sm:text-5xl">
          Privacy Policy
        </h1>
        <AirtablePage
          :block-map="blockMap"
          :loading="loading"
        />
      </div>
    </div>
    <airtable-forms-footer />
  </div>
</template>

<script setup>
import { useNotionPagesStore } from "~/stores/notion_pages.js"
import { computed } from "vue"

useAirtableFormsSeoMeta({
  title: "Privacy Policy",
})
defineRouteRules({
  swr: 3600,
})

const pageId = "a63e96abb500479aa805747afe6613a5"
const notionPageStore = useNotionPagesStore()
await notionPageStore.load(pageId)

const loading = computed(() => notionPageStore.loading)
const blockMap = computed(() => notionPageStore.getByKey(pageId))
</script>
